<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EfnogZ/images/9780316195980.jpg?1733067619838" alt="This image is the cover for the book Hell of a Woman, Mulholland Classic"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hell of a Woman, Mulholland Classic
      </h1>
      <p class="bookDescription body article font2">
        <p>Frank "Dolly" Dillon has a job he hates, working sales and collections for Pay-E-Zee Stores, a wife named Joyce he can't stand, and an account balance that barely allows him to pay the bills each month. Working door-to-door one day, trying to eke money out of folk with even less of it than he has, Dolly crosses paths with a beautiful young woman named Mona Farrell. Mona's being forced by her aunt to do things she doesn't like, with men she doesn't know -- she wants out, any way she can get it. And to a man who wants nothing of what he has, Mona sure looks like something he actually does. <br/><br/> Soon Dolly and Mona find themselves involved in a scheme of robbery, murder and mayhem that makes Dolly's blood run cold. As Dolly's plans begin to unravel, his mind soon follows. <br/><br/> In <i>A Hell of a Woman</i>, Jim Thompson offers another arresting portrait of a deviant mind, in an ambitious crime novel that ranks among his best work.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jim Thompson
      </h2>
      
      <p class="authorDescription body article"><B>Jim Thompson</B> was born in Anadarko, Oklahoma. He began writing fiction at a very young age, selling his first story to <I>True Detective</I> when he was only fourteen. Thompson eventually wrote twenty-nine novels, all but three of which were published as paperback originals. <br><br> Thompson also co-wrote two screenplays (for the Stanley Kubrick films The Killing and Paths of Glory). Several of his novels have been filmed by American and French directors, resulting in classic noir including <I>The Killer Inside Me</I> (1952), <I>After Dark My Sweet</I> (1955), and <I>The Grifters</I> (1963).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Little, Brown and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?372e2a54